// Payment proofs live in a PRIVATE bucket and open via short-lived signed URLs.
import { showToast } from "../ui/core";
import { PROOF_BUCKET } from "./api";
import { fileUrl, isR2 } from "../lib/fileStore";

const PUBLIC_MARKER = `/storage/v1/object/public/${PROOF_BUCKET}/`;

// Accepts either the stored object path or a legacy public URL.
export function proofObjectPath(ref) {
    if (!ref) return null;
    if (isR2(ref)) return ref;
    const i = ref.indexOf(PUBLIC_MARKER);
    if (i >= 0) return decodeURIComponent(ref.slice(i + PUBLIC_MARKER.length).split("?")[0]);
    if (/^(https?:|data:)/i.test(ref)) return null;
    return ref;
}

export async function openProof(ref) {
    const path = proofObjectPath(ref);
    if (!path) { window.open(ref, "_blank", "noopener,noreferrer"); return; }
    const win = window.open("", "_blank");
    let url = null;
    try { url = await fileUrl(PROOF_BUCKET, path); } catch { url = null; }   // R2 (signed by r2-files) or the bucket, 5 minutes
    if (!url) {
        if (win) win.close();
        showToast("Could not open payment proof.", "#ef4444");
        return;
    }
    if (win) win.location.href = url; else window.location.href = url;
}

export const proofLinkProps = (ref) => ({ href: "#", onClick: (e) => { e.preventDefault(); e.stopPropagation(); openProof(ref); } });
